<template>
  <div style="margin-top:67px; background-color: #fafafa;">
    <step :isActiveCustomer="true"></step>
    <section class="desktop">
      <div class="customer-wrapper">
        <b-container>
          <b-row>
            <b-col sm="11" md="6" offset-md="3">
              <div style="margin-top: 20px;">
                우체국 택배로
                <span class="bold">{{deliveryAtMonth}}월 {{deliveryAtDay}}일</span>에 보내드려요
                <router-link :to="{ name: 'FreeTrial' }">
                  <p class="freetrial-descripion">진짜 무료인가요?</p>
                </router-link>
              </div>
              <div class="name-phone">
                <div id="wrap" ref="wrap"></div>
                <div class="flexbox">
                  <span>이름</span>
                  <div class="width-70">
                    <input type="text" class="width-100" v-model="name">
                  </div>
                </div>
                <div class="flexbox">
                  <span>{{phoneNumberField}}</span>
                  <div class="flexbox width-70" v-bind:class="{hidden: !showAuthBtn}">
                    <input type="tel" v-model="phoneNumber">
                    <button @click="sendAuthNumber">인증번호 전송</button>
                  </div>
                  <div class="flexbox width-70 hidden" v-bind:class="{show: !showAuthBtn}">
                    <input type="tel" v-model="authNumber">
                    <button @click="authenticate">인증</button>
                  </div>
                </div>
              </div>
              <div class="address">
                <div class="flexbox" style="position: relative;">
                  <span>주소</span>
                  <div class="flexbox width-70">
                    <input v-model="mainAddress" readonly>
                    <button @click="findAddress">우편번호 찾기</button>
                  </div>
                </div>
                <div class="flexbox">
                  <span>상세주소</span>
                  <div class="width-70">
                    <input class="width-100" v-model="subAddress">
                  </div>
                </div>
              </div>
              <div class="m-service-agreement-wrapper">
                <div>
                  <input
                    type="checkbox"
                    class="service-agreement-input"
                    id="service-agreement-input"
                    v-model="isAgreedAll"
                  >
                  <label
                    for="service-agreement-input"
                    @click="toggleIsAgreedAll(isAgreedAll)"
                    class="service-agreement-checkbox"
                    v-bind:class="{active: isAgreedAll}"
                  ></label>
                  <span>전체 동의</span>
                </div>
                <div>
                  <input
                    type="checkbox"
                    class="service-agreement-input"
                    id="service-agreement-input2"
                    v-model="isAgreedConditions"
                  >
                  <label
                    for="service-agreement-input2"
                    @click="toggleIsAgreed(isAgreedConditions)"
                    class="service-agreement-checkbox"
                    v-bind:class="{active: isAgreedConditions}"
                  ></label>
                  <span>
                    <router-link :to="{ name: 'Terms' }">개인 정보 보호</router-link>에 동의합니다.
                  </span>
                </div>
                <div>
                  <input
                    type="checkbox"
                    class="service-agreement-input"
                    id="service-agreement-input3"
                    v-model="isAgreedMarketing"
                  >
                  <label
                    for="service-agreement-input3"
                    @click="toggleIsAgreed(isAgreedMarketing)"
                    class="service-agreement-checkbox"
                    v-bind:class="{active: isAgreedMarketing}"
                  ></label>
                  <span>
                    <router-link :to="{ name: 'Terms' }">마케팅 정보 수신</router-link>에 동의합니다.
                  </span>
                </div>
                <div>
                  <input
                    type="checkbox"
                    class="service-agreement-input"
                    id="service-agreement-input4"
                    v-model="isAgreedTerm"
                  >
                  <label
                    for="service-agreement-input4"
                    @click="toggleIsAgreed(isAgreedTerm)"
                    class="service-agreement-checkbox"
                    v-bind:class="{active: isAgreedTerm}"
                  ></label>
                  <span>
                    <router-link :to="{ name: 'Terms' }">서비스 이용 약관</router-link>에 동의합니다.
                  </span>
                </div>
              </div>
              <button style="cursor: pointer;" class="complete-btn" @click="goCard">{{buttonText}}</button>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </section>
    <section class="mobile">
      <div class="m-customer-wrapper">
        <div id="mwrap" ref="mwrap"></div>
        <div style="padding: 15px;">
          <span>
            우체국 택배로
            <span class="bold">{{deliveryAtMonth}}월 {{deliveryAtDay}}일</span>에 보내드려요
          </span>
          <router-link :to="{ name: 'FreeTrial' }">
            <p class="freetrial-descripion">진짜 무료인가요?</p>
          </router-link>
        </div>
        <div class="m-name-input left">
          <label for>이름</label>
          <div class="flexbox m-row width-100">
            <input type="text" v-model="name">
          </div>
        </div>
        <div class="m-phone-input left">
          <label for>{{phoneNumberField}}</label>
          <div class="flexbox m-row" v-bind:class="{hidden: !showAuthBtn}">
            <input type="text" v-model="phoneNumber" size="15">
            <button @click="sendAuthNumber">인증번호 전송</button>
          </div>
          <div class="flexbox m-row hidden" v-bind:class="{show: !showAuthBtn}">
            <input type="text" v-model="authNumber" size="15">
            <button @click="authenticate">인증</button>
          </div>
        </div>
        <div class="m-address-input left">
          <label for>주소</label>
          <div class="flexbox m-row" style="position: relative">
            <input type="text" v-model="mainAddress" size="15" readonly>
            <button @click="findAddressMobile">우편번호 찾기</button>
          </div>
        </div>
        <div class="m-sub-address-input left">
          <label for>상세주소</label>
          <div class="flexbox m-row">
            <input type="text" v-model="subAddress">
          </div>
        </div>
        <div class="m-service-agreement-wrapper">
          <div>
            <input
              type="checkbox"
              class="service-agreement-input"
              id="service-agreement-input"
              v-model="isAgreedAll"
            >
            <label
              for="service-agreement-input"
              @click="toggleIsAgreedAll(isAgreedAll)"
              class="service-agreement-checkbox"
              v-bind:class="{active: isAgreedAll}"
            ></label>
            <span>전체 동의</span>
          </div>
          <div>
            <input
              type="checkbox"
              class="service-agreement-input"
              id="service-agreement-input2"
              v-model="isAgreedConditions"
            >
            <label
              for="service-agreement-input2"
              @click="toggleIsAgreed(isAgreedConditions)"
              class="service-agreement-checkbox"
              v-bind:class="{active: isAgreedConditions}"
            ></label>
            <span>
              <router-link :to="{ name: 'Terms' }">개인 정보 보호</router-link>에 동의합니다.
            </span>
          </div>
          <div>
            <input
              type="checkbox"
              class="service-agreement-input"
              id="service-agreement-input3"
              v-model="isAgreedMarketing"
            >
            <label
              for="service-agreement-input3"
              @click="toggleIsAgreed(isAgreedMarketing)"
              class="service-agreement-checkbox"
              v-bind:class="{active: isAgreedMarketing}"
            ></label>
            <span>
              <router-link :to="{ name: 'Terms' }">마케팅 정보 수신</router-link>에 동의합니다.
            </span>
          </div>
          <div>
            <input
              type="checkbox"
              class="service-agreement-input"
              id="service-agreement-input4"
              v-model="isAgreedTerm"
            >
            <label
              for="service-agreement-input4"
              @click="toggleIsAgreed(isAgreedTerm)"
              class="service-agreement-checkbox"
              v-bind:class="{active: isAgreedTerm}"
            ></label>
            <span>
              <router-link :to="{ name: 'Terms' }">서비스 이용 약관</router-link>에 동의합니다.
            </span>
          </div>
        </div>
        <div class="m-button-wrapper">
          <button class="complete-btn" @click="goCard">{{buttonText}}</button>
        </div>
      </div>
    </section>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Step from './Step'
import AppFooter from '../AppFooter'
import {convertProductNameFrom} from '../../modules/products'
import {PAYMENT_METHOD_BY_NUM, convertPaymentMethodInStrBy} from '../../modules/payment_methods'
import {findMainAddress, isExistCreditCard, isCellPhone} from '../../modules/modules.js'
const alertOptions = {title: '', size: 'sm', okLabel: '확인'}

export default {
  name: 'customer',
  components: { Step, AppFooter },
  data () {
    return {
      isInput: false,
      showAuthBtn: true,
      showRecommendBtn: true,
      name: '',
      customerId: '',
      phoneNumber: '',
      authNumber: '',
      accessTokenId: '',
      mainAddress: '',
      subAddress: '',
      postalCode: '',
      isAuth: false,
      isCreditCardAvailabe: false,
      buttonText: '무료체험 신청 완료',
      phoneNumberField: '휴대폰 번호',
      deliveryAtMonth: '',
      deliveryAtDay: '',
      isAgreedTerm: false,
      isAgreedConditions: false,
      isAgreedMarketing: false,
      isAgreedAll: false

    }
  },
  mounted () {
    this.deliveryAtMonth = this.deliveryAt.split('-')[1]
    this.deliveryAtDay = this.deliveryAt.split('-')[2]
  },
  computed: {
    cartItems () {
      return this.$store.state.cartItems
    },
    applicant () {
      return this.$store.state.applicant
    },
    applicantProducts () {
      return this.$store.state.applicantProducts
    },
    numberOfCartItems () {
      return this.$store.state.numberOfCartItems
    },
    deliveryAt () {
      return this.$store.state.deliveryAt
    }
  },
  methods: {
    async createFreeTrial () {
      var isComplete = false
      for (var i = 0; i < this.applicantProducts.length; i++) {
        let data = new FormData()
        data.append('event_id', this.applicant.eventId)
        data.append('product_id', this.applicantProducts[i])
        data.append('customer_id', this.applicant.customerId)
        data.append('payment_method', convertPaymentMethodInStrBy(this.applicant.paymentMethod))
        await this.$http.post(process.env.URL_EVENT_SERVICE + '/v1/free-trials/', data)
          .then((result) => {
            if (result.status === 201) {
              isComplete = true
            } else {
              this.$dialogs.alert('죄송합니다. 서버와의 통신에 실패하였습니다. 고객센터로 문의해주세요.', alertOptions)
            }
          })
          .catch((error) => {
            if (error.response.status === 500 || error.response.status === 504) {
              this.$dialogs.alert('죄송합니다. 현재 접속자가 많아 카드 정보를 등록하는데 실패했습니다. \n' +
            '새로고침 후에 다시 시도해주세요 !', alertOptions)
            } else if (error.response.status === 406 && error.response.data.code === 31) {
              this.$dialogs.alert('죄송합니다. 이미 무료체험을 신청하셨습니다.', alertOptions)
            } else if (error.response.status === 406 && error.response.data.code === 30) {
              this.$dialogs.alert('죄송합니다. 쓰다가 구매하기가 매진되었습니다. 바로 구매하기로 신청해보시겠어요?', alertOptions)
            } else if (error.response.status === 400 && error.response.data.code === 26) {
              this.$dialogs.alert('죄송합니다. 제품이 매진되었습니다. 조금만 기다려주시면 다시 신청을 재개하겠습니다.', alertOptions)
            } else if (error.response.status === 400 && error.response.data.code === 12) {
              this.$dialogs.alert('죄송합니다. 무료체험이 마감되었습니다. 다음 무료체험 모집을 기다려주세요.', alertOptions)
            } else if (error.response.status === 406 && error.response.data.code === 146) {
              this.$dialogs.alert('죄송합니다. 무료체험을 2회이상 반납하셔서 신청이 불가능한 제품이 있습니다. ' + convertProductNameFrom(this.applicantProducts[i]), alertOptions)
              let payload = {
                id: this.applicantProducts[i]
              }
              this.$store.commit('removeItem', payload)
            } else {
              this.$dialogs.alert('죄송합니다. 서버와의 통신에 실패하였습니다. 고객센터로 문의해주세요.', alertOptions)
            }
          })
      }
      if (isComplete) {
        this.$router.push({ name: 'Complete' })
      }
    },
    async enrollFreeTrial () {
      if (this.numberOfCartItems === 0) {
        this.$dialogs.alert('장바구니에 담긴 제품이 없습니다 ! 제품을 먼저 골라주세요.', alertOptions)
        this.isClicked = false
        return
      }

      let eventInfo = await this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/events/advertising/')
      if (eventInfo.status === 204) {
        this.$dialogs.alert('무료체험이 매진되었습니다. 곧 다시 모집할테니 걱정마세요!', alertOptions)
        return
      }
      this.$store.commit({
        type: 'addApplicantInfo',
        key: 'eventId',
        value: eventInfo.data.id
      })

      let stockInfo = await this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/events/' + eventInfo.data.id + '/stocks/')
      for (var i = 0; i < this.cartItems.length; i++) {
        for (var j = 0; j < stockInfo.data.results.length; j++) {
          if (stockInfo.data.results[j].product_id === this.cartItems[i].id) {
            if (stockInfo.data.results[j].available_quantity === 0) {
              let name = convertProductNameFrom(this.cartItems[i].id)
              this.$dialogs.alert(name + '는 품절되었습니다.', alertOptions)
              return
            }
          }
        }
      }
      if (this.applicant.paymentMethod === PAYMENT_METHOD_BY_NUM.LEASE) {
        if (eventInfo.data.available_lease_quantity < this.cartItems.length) {
          this.$dialogs.alert('앗! 분할 결제 방식은 매진되었습니다. 일시불 방식으로 신청은 어떠세요?', alertOptions)
          return
        }
      }
      this.createFreeTrial()
    },
    async goCard () {
        if (this.isAgreedTerm === false || this.isAgreedConditions === false) {
          this.$dialogs.alert('서비스 이용약관과 개인정보 취급 정책 동의는 필수입니다.')
          return
        }
        if (this.numberOfCartItems === 0) {
          this.$dialogs.alert('장바구니에 담긴 제품이 없습니다 ! 제품을 먼저 골라주세요.', alertOptions)
          return
        }
        let eventInfo = await this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/events/advertising/')
        if (eventInfo.status === 204) {
          this.$dialogs.alert('무료체험이 매진되었습니다. 곧 다시 모집할테니 걱정마세요!', alertOptions)
          return
        }
        if (this.isAgreedMarketing === true) {
          let payload = new FormData()
          payload.append('customer', this.customerId)
          await this.$http.post(process.env.URL_EVENT_SERVICE + '/v1/customers/subscriptions/marketing/', payload)
        }
        let stockInfo = await this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/events/' + eventInfo.data.id + '/stocks/')
        for (var i = 0; i < this.cartItems.length; i++) {
          for (var j = 0; j < stockInfo.data.results.length; j++) {
            if (stockInfo.data.results[j].product_id === this.cartItems[i].id) {
              if (stockInfo.data.results[j].available_quantity === 0) {
                let name = convertProductNameFrom(this.cartItems[i].id)
                this.$dialogs.alert(name + '는 품절되었습니다.', alertOptions)
                return
              }
            }
          }
        }
        if (this.applicant.paymentMethod === PAYMENT_METHOD_BY_NUM.LEASE) {
          if (eventInfo.data.available_lease_quantity < this.cartItems.length) {
            this.$dialogs.alert('앗! 분할 결제 방식은 매진되었습니다. 일시불 방식으로 신청은 어떠세요?', alertOptions)
            this.$router.push({ name: 'Plan' })
          }
        }

        if (this.mainAddress === '' || this.subAddress === '') {
          this.$dialogs.alert('정보를 모두 입력해주세요.', alertOptions)
        } else {
          if (this.isAuth) {
            if (this.isCreditCardAvailabe) {
              await this.createAddress()
              this.enrollFreeTrial()
            } else {
              await this.createAddress()
              await this.createCard()
            }
          } else {
            this.$dialogs.alert('인증을 거치지 않았습니다. 전화번호를 인증해주세요!', alertOptions)
          }
        }
    },
    async createAddress () {
      let data = new FormData()
      data.append('customer', this.customerId)
      data.append('main_address', this.mainAddress)
      data.append('sub_address', this.subAddress)
      data.append('postal_code', this.postalCode)
      await this.$http.post(process.env.URL_EVENT_SERVICE + '/v1/addresses/', data)
        .then((result) => {
          if (result.status === 201 || result.status === 200) {
          } else if (result.status === 500 || data.status === 504) {
            this.$dialogs.alert('죄송합니다. 현재 접속자가 많아 주소 정보를 등록하지 못했습니다. 다시 시도해주세요!', alertOptions)
          } else {
            this.$dialogs.alert('죄송합니다. 주소를 등록하는 과정에서 에러가 발생하였습니다. 고객센터(02-9272-6212)로 문의 해주세요.', alertOptions)
          }
        })
    },
    async createCustomer () {
      let data = new FormData()
      data.append('name', this.name)
      data.append('phone_number', this.phoneNumber)
      data.append('marketing_subscription', this.isAgreedMarketing)
      await this.$http.post(process.env.URL_EVENT_SERVICE + '/v1/customers/', data)
        .then(async (result) => {
          if (result.status === 201) {
            this.customerId = result.data.id
            this.$store.commit({
              type: 'addApplicantInfo',
              key: 'customerId',
              value: result.data.id
            })
          }
        })
        .catch(async (error) => {
          if (error.response.status === 409) {
            let customer = await this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/customers/?search=' + this.phoneNumber)
            this.customerId = customer.data[0].id
            this.$store.commit({
              type: 'addApplicantInfo',
              key: 'customerId',
              value: customer.data[0].id
            })
            let data = new FormData()
            data.append('key', 'name')
            data.append('value', this.name)
            await this.$http.put(process.env.URL_EVENT_SERVICE + '/v1/customers/' + customer.data[0].id + '/', data)

            let addressInfo = await this.$http.get(process.env.URL_ADMIN_API_SERVICE + '/v1/addresses/?search=' + customer.data[0].id)
            let index = findMainAddress(addressInfo.data)
            this.mainAddress = addressInfo.data[index].main_address
            this.subAddress = addressInfo.data[index].sub_address
            this.postalCode = addressInfo.data[index].postal_code

            this.$dialogs.alert('I/O 고객이시군요! 주소를 확인해주세요.', alertOptions)

            let creditCardInfo = await this.$http.get(process.env.URL_ADMIN_API_SERVICE + '/v1/credit-cards/?search=' + customer.data[0].id)
            if (isExistCreditCard(creditCardInfo.data)) {
              this.buttonText = '무료체험 신청 완료'
              this.isCreditCardAvailabe = true
            }
          } else {
            this.$dialogs.alert('죄송합니다. 서버와의 통신에 실패하였습니다. 고객센터로 문의해주세요.', alertOptions)
          }
        })
    },
    async createCard () {
      let eventInfo = await this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/events/advertising/')
      if (eventInfo.status === 204) {
        this.$dialogs.alert('무료체험이 매진되었습니다. 곧 다시 모집할테니 걱정마세요!', alertOptions)
        return
      }
      this.$store.commit({
        type: 'addApplicantInfo',
        key: 'eventId',
        value: eventInfo.data.id
      })
      let data = new FormData()
      data.append('customer', this.applicant.customerId)
      data.append('card_number', '0000000000000000')
      data.append('company_name', '기본등록')
      data.append('expiration_year', '3000')
      data.append('expiration_month', '01')
      await this.$http.post(process.env.URL_EVENT_SERVICE + '/v1/credit-cards/', data)
        .then((result) => {
          if (result.status === 201) {
            this.createFreeTrial()
          } else {
            this.$dialogs.alert('죄송합니다. 서버와의 통신에 실패하였습니다. 고객센터로 문의해주세요.', alertOptions)
          }
        })
        .catch((error) => {
          if (error.response.status === 500 || error.response.status === 504) {
            this.$dialogs.alert('죄송합니다. 현재 접속자가 많아 카드 정보를 등록하는데 실패했습니다. \n' +
            '새로고침 후에 다시 시도해주세요 !', alertOptions)
          } else if (error.response.status === 400 && error.response.data.code === 56) {
            this.$dialogs.alert('카드번호가 올바르지 않습니다.', alertOptions)
          } else if (error.response.status === 400 && error.response.data.code === 57) {
            this.createFreeTrial()
          } else {
            this.$dialogs.alert('죄송합니다. 서버와의 통신에 실패하였습니다. 고객센터로 문의해주세요.', alertOptions)
          }
        })
    },
    findAddress: function () {
      let vm = this
      /*eslint-disable */
    new daum.Postcode({
        oncomplete: function (data) {
          vm.postalCode = data.zonecode
          vm.mainAddress = data.roadAddress
          vm.isInput = true
        }
      }).embed(this.$refs.wrap)
    /* eslint-enable */
    },
    findAddressMobile: function () {
      let vm = this
      this.$refs.mwrap.style.display = 'block'
      /*eslint-disable */
    new daum.Postcode({
        oncomplete: function (data) {
          vm.postalCode = data.zonecode
          vm.mainAddress = data.roadAddress
          vm.isInput = true
          vm.$refs.mwrap.style.display = 'none'
        },
        onresize: function(size) {
          vm.$refs.mwrap.style.height = size.height + 'px'
        },
        width: '100%',
        height: '100%'
      }).embed(this.$refs.mwrap)
    /* eslint-enable */
    },
    sendAuthNumber: function () {
      if (this.name === '') {
        this.$dialogs.alert('이름을 먼저 입력해주세요!', alertOptions)
        return
      }
      if (!isCellPhone(this.phoneNumber)) {
        this.$dialogs.alert('휴대폰번호를 확인해주세요!', alertOptions)
        return
      }
      this.showAuthBtn = false
      this.createCustomer()
      let data = new FormData()
      data.append('phone_number', this.phoneNumber)
      this.$http.post(process.env.URL_EVENT_SERVICE + '/v1/access-tokens/', data)
        .then((result) => {
          if (result.status === 201) {
            this.$dialogs.alert('인증번호를 전송하였습니다.', alertOptions)
            this.accessTokenId = result.data.id
            this.phoneNumberField = '인증번호'
          } else {
            this.$dialogs.alert('인증번호 전송 실패! 고객센터에 문의해주세요.', alertOptions)
          }
        })
    },
    authenticate: function () {
      this.$http.get(process.env.URL_EVENT_SERVICE + '/v1/access-tokens/' + this.accessTokenId + '/?authentication_number=' + this.authNumber)
        .then((result) => {
          if (result.status === 200) {
            this.$dialogs.alert('인증에 성공하였습니다.', alertOptions)
            this.isAuth = true
            this.migrateCustomer(this.phoneNumber)
          } else {
            this.$dialogs.alert('인증번호를 다시 확인해주세요.', alertOptions)
          }
        })
    },
    migrateCustomer: function (number) {
      let data = new FormData()
      data.append('key', 'phone_number')
      data.append('value', number)
      this.$http.post(process.env.URL_ADMIN_API_SERVICE + '/v1/migrations/customers/', data)
    },
    toggleIsAgreed: function (data) {
      data = !data
    },
    toggleIsAgreedAll: function () {
      this.isAgreedTerm = true
      this.isAgreedMarketing = true
      this.isAgreedConditions = true
      this.isAgreedAll = !this.isAgreedAll
    }
  }
}
</script>

<style scoped>

.name-phone {
  margin-top: 50px;
}
.address {
  border-top: solid 1px #dee2e5;
  padding-top: 25px;
  margin-top: 25px;
}
.flexbox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 47px;
  margin-bottom: 20px;
}
.width-70 {
  width: 70%;
  height: 100%;
}
.width-100 {
  width: 100%;
  height: 100%;
}

input {
  padding: 20px;
  width: 65%;
  border: solid 1px #eef0f1;
  border-radius: 2px;
  height: 100%;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.mobile input {
  width: 60%;
}

button {
  border-radius: 2px;
  background-color: #dee2e5;
  font-size: 14px;
  letter-spacing: -0.4px;
  color: #3d4953;
  border: 0;
  height: 100%;
  width: 121px;
  cursor: pointer;
}

button:hover {
  background-color: #b3c2cc;
}

.noInput {
  border: solid 1px #fe5c5c;
}

.m-no-input-msg {
  font-size: 12px;
  color: #fe5c5c;
}
.no-input-msg {
  font-size: 12px;
  color: #fe5c5c;
  position: absolute;
  top: 42px;
  display: none;
}
.recommend-msg {
  font-size: 12px;
  position: absolute;
  top: 42px;
  text-decoration: underline;
}

.recommend-msg a {
  color: #6f97fa !important;
}
.m-recommend-msg {
  font-size: 12px;
  text-decoration: underline;
}
.m-recommend-msg a {
  color: #6f97fa !important;
}

.hidden {
  display: none;
}
.show {
  display: flex;
}

.complete-btn {
  border-radius: 2px;
  background-color: #6f97fa;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: -0.5px;
  width: 240px;
  height: 50px;
  margin-bottom: 50px;
}
.complete-btn:hover {
  background-color: #5686fe;
}

.m-customer-wrapper {
  padding: 15px;
}
.m-row {
  height: 47px;
}
.m-name-input .m-row input {
  width: 100%;
}
.m-phone-input {
  border-bottom: solid 1px #dee2e5;
}

/* .m-sub-address-input {
  border-bottom: solid 1px #dee2e5;
} */
.m-sub-address-input .m-row input {
  width: 100%;
}

.m-address-input {
  margin-top: 10px;
  position: relative;
}
.m-address-input .m-row {
  margin-bottom: 0px;
}

.m-recommend-input {
  margin-top: 10px;
  position: relative;
}

.left {
  text-align: left;
}
.m-recommend-input .m-row {
  margin-bottom: 0px;
}

.freetrial-descripion {
  font-size: 14px;
  text-decoration: underline;
  color: #6f97fa;
  margin: 0;
}

.m-service-agreement-wrapper {
  margin-top: 30px;
  margin-bottom: 30px;
  border-top: solid 1px #dee2e5;
  font-size: 12px;
  text-align: left;
  padding: 15px;
}
.m-service-agreement-wrapper a {
  color: #3d2731;
}

.service-agreement-checkbox {
  width: 20px;
  height: 20px;
  background: url("../../assets/check-disable.png") center no-repeat;
  background-size: 20px;
  position: relative;
  top: 13px;
  right: 6px;
}
.service-agreement-checkbox.active {
  background: url("../../assets/check-active.png") center no-repeat;
  background-size: 20px;
}

.service-agreement-input {
  display: none;
}

.underline {
  text-decoration: underline;
}

</style>



// WEBPACK FOOTER //
// src/components/apply/Customer.vue